module.exports = __webpack_public_path__ + "img/45_4.7ef4dd4c.png";